export const Theme = {
  primary: 'rgb(8, 5, 117)',
  secondary: '#fff',
  grey: '#707070',
  purple: '#7f43f5',
  grey45: '#fff',
  light: '#f6f6f6',
  'secondary-light': '#f5f5f6'
};
